import React from 'react'
import clsx from 'clsx'

/**
 * @interface AnimatedMenuIconProps
 * @description Defines the properties for the AnimatedMenuIcon component.
 */
interface AnimatedMenuIconProps {
	/** Current state of the menu */
	isOpen: boolean
	/** Callback function triggered on click */
	onToggle: () => void
	/** Optional tailwind classes for the button container */
	className?: React.HTMLAttributes<HTMLElement>['className']
}

/**
 * @component HamburgerMenu
 * @description Animated hamburger-to-X menu button using pure CSS transitions.
 * No GSAP dependency — keeps GSAP out of the eager bundle to reduce TBT.
 */
const HamburgerMenu: React.FC<AnimatedMenuIconProps> = ({ isOpen = false, onToggle, className }) => (
	<button
		onClick={ onToggle }
		className={clsx(
			'cursor-pointer flex flex-col items-center justify-center gap-[5px] rounded-full hover:opacity-75 duration-200',
			className,
			'size-6 sm:size-10'
		)}
		aria-label={ isOpen ? 'Close Menu' : 'Open Menu' }
		aria-expanded={ isOpen }
	>
		<span className={clsx(
			'block h-[2.5px] w-[26px] bg-white rounded-full origin-center transition-transform duration-300',
			isOpen && 'translate-y-[7.5px] rotate-45'
		)} />
		<span className={clsx(
			'block h-[2.5px] w-[26px] bg-white rounded-full transition-opacity duration-200',
			isOpen && 'opacity-0'
		)} />
		<span className={clsx(
			'block h-[2.5px] w-[26px] bg-white rounded-full origin-center transition-transform duration-300',
			isOpen && '-translate-y-[7.5px] -rotate-45'
		)} />
	</button>
)

export default HamburgerMenu
